import React from "react";
import { Link } from "react-router-dom";
import { Scroll, Scale, FileWarning, Download } from "lucide-react";

const LINKS = [
  { to: "/rules", label: "Rules", Icon: Scroll, testId: "footer-link-rules" },
  { to: "/disclaimer", label: "Disclaimer", Icon: Scale, testId: "footer-link-disclaimer" },
  { to: "/disclaimer", label: "DMCA", Icon: FileWarning, testId: "footer-link-dmca" },
  { to: "/software", label: "Clients", Icon: Download, testId: "footer-link-clients" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="mt-12 border-t border-[var(--tt-border)] bg-black/40 backdrop-blur-sm px-4 md:px-8 py-5"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-[11px] text-[var(--tt-text-muted)] font-mono-tt">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--tt-primary)] shadow-[0_0_8px_var(--tt-primary)]" />
          <span>
            © {year} <span className="text-white/80 font-semibold">TorHub</span> · metadata &amp; magnet
            search · we host nothing
          </span>
        </div>
        <nav className="flex flex-wrap items-center gap-1.5" aria-label="Footer">
          {LINKS.map(({ to, label, Icon, testId }) => (
            <Link
              key={testId}
              to={to}
              data-testid={testId}
              className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-semibold text-[var(--tt-text-muted)] hover:text-white px-2.5 py-1.5 rounded-full hover:bg-white/5 transition-colors"
            >
              <Icon className="w-3 h-3" />
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
